import { render, staticRenderFns } from "./reg.vue?vue&type=template&id=42717150&scoped=true&"
import script from "./reg.vue?vue&type=script&lang=js&"
export * from "./reg.vue?vue&type=script&lang=js&"
import style0 from "./reg.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"
import style1 from "./reg.vue?vue&type=style&index=1&id=42717150&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42717150",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\tavo\\source\\repos\\GEG\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('42717150', component.options)
    } else {
      api.reload('42717150', component.options)
    }
    module.hot.accept("./reg.vue?vue&type=template&id=42717150&scoped=true&", function () {
      api.rerender('42717150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\views\\registration\\reg.vue"
export default component.exports